import Icon from '../components/Icon.vue'

Icon.register({
  dolly: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M294.2 277.7l-53-159.4c-2.8-8.3 1.7-17.4 10.1-20.2l61.6-20.5 33.1 99.4 60.7-20.1-33.1-99.4 61.1-20.4c8.3-2.8 17.4 1.7 20.2 10.1l60.4 181.2c2.8 8.3-1.7 17.4-10.1 20.2l-161.5 53.8c-14.8-11.3-31.5-19.7-49.5-24.7zM575.2 326.4c2.8 8.4-1.8 17.4-10.1 20.2l-213.3 71.2c-1.1 57.8-53.2 103.3-113.4 92.6-39.4-6.9-71.2-39.8-77.3-79.2-5.7-36.9 9.9-70.1 36-90.5l-92.2-276.7h-88.9c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h112c13.8 0 26 8.8 30.4 21.9l99.4 298.2c29.9 0.6 56.3 15 73.5 37l213.5-71.2c8.3-2.8 17.4 1.7 20.2 10.1zM256 464c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})
